module.exports = __webpack_public_path__ + "static/media/screenshot.bd49157b.png";